import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    fallback: { type: String, default: "/tutor-jobs" }
  }

  goBack(event) {
    event.preventDefault()

    // If referrer exists and is from the same host, go back in history.
    // Otherwise, redirect to the fallback URL.
    if (document.referrer && document.referrer.includes(window.location.host)) {
      window.history.back()
    } else {
      window.location.href = this.fallbackValue
    }
  }
}
